import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import SubCategories from "../../components/SubCategories";

const SubCategoriesPage = () => {
  return (
    <div className="md:flex md:justify-center">
      <div className="p-3 md:flex md:flex-row">
        <SubCategories />
      </div>
    </div>
  );
};

export default SubCategoriesPage;
